// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"218":"33cf41791a8a756f","888":"33cf41791a8a756f"}[chunkId] + ".css";
};